import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ValueBox } from '../../molecules/value-box';
import { Group } from '../../organisms/group';
import { ServiceAccessInput } from '../../organisms/settings/service-access-input';
import { ShelliesTable } from '../../molecules/shellies-table';
import { useSelector } from '../../store/utils';
import { SwitchBox } from '../../molecules/switch-box';
import { InputBox } from '../../molecules/input-box';
import { EnergyMetersSettings } from '../../organisms/energy-meters-settings';

const Shellies = () => {
  const [serviceActive, running, shellies] = useSelector(
    ({ variables }) =>
      [
        variables.SERVICE_ACTIVE,
        variables.MQTT_BROKER_RUNNING,
        variables.MQTT_BROKER_SHELLIES,
      ] as const
  );

  if (!serviceActive) {
    return (
      <Group
        layout="list"
        title={
          <FormattedMessage id="shellies.title" defaultMessage="Shellies" />
        }
      >
        <ServiceAccessInput />
      </Group>
    );
  }

  return (
    <>
      <Group
        layout="list"
        title={
          <FormattedMessage id="shellies.title" defaultMessage="Shellies" />
        }
      >
        <ValueBox
          type="row"
          title={
            <FormattedMessage
              id="shellies.mqtt_broker_running"
              defaultMessage="Stav MQTT Brokerka"
            />
          }
          value={running ? 'Aktivní' : 'Neaktivní'}
        />

        <ShelliesTable />
      </Group>
      <Group
        layout="list"
        title={
          <FormattedMessage id="shellies.settings" defaultMessage="Nastavení" />
        }
      >
        <SwitchBox
          title={
            <FormattedMessage
              id="shellies.settings.boiler.active"
              defaultMessage="Bojler připojený přes Shellies"
            />
          }
          switchVariableId="HW_SHELLIES"
          fullWidth
        />
        <InputBox
          title={
            <FormattedMessage
              id="shellies.settings.boiler.id"
              defaultMessage="ID shellies"
            />
          }
          inputVariableId="HW_SHELLIES_ID"
          visibility={{ variableId: 'HW_SHELLIES' }}
          label={
            <FormattedMessage
              id="shellies.settings.boiler.id.label"
              defaultMessage="ID"
            />
          }
          fullWidth
        />
      </Group>

      <EnergyMetersSettings />
    </>
  );
};

export default Shellies;
